class PageTransition extends HTMLElement {
  static get observedAttributes() {
    return ['duration'];
  }

  constructor() {
    super();
    this.duration = parseInt(this.getAttribute('duration')) || 350;
    this._handleClick = this._handleClick.bind(this);
    this._handlePageShow = this._handlePageShow.bind(this);
    this._cancelNavigation = this._cancelNavigation.bind(this);
    this._navigationTimer = null;
    this._navigating = false;
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === 'duration') {
      const val = parseInt(newValue, 10);
      this.duration = !isNaN(val) && val >= 0 ? val : 350;
    }
  }

  connectedCallback() {
    if (this.hasAttribute('duration')) {
      this.attributeChangedCallback('duration', null, this.getAttribute('duration'));
    }

    this.classList.add('active');

    const isReload = this._isReload();
    if (isReload) {
      this._hideInstant();
    } else {
      requestAnimationFrame(() => this.classList.remove('active', 'no-transition'));

    }

    document.body.addEventListener('click', this._handleClick);
    window.addEventListener('pagehide', this._cancelNavigation);
    window.addEventListener('pageshow', this._handlePageShow);
  }

  disconnectedCallback() {
    document.body.removeEventListener('click', this._handleClick);
    window.removeEventListener('pageshow', this._handlePageShow);
    window.removeEventListener('pagehide', this._cancelNavigation);
    this._cancelNavigation();
  }

  _isReload() {
    try {
      const nav = performance.getEntriesByType?.("navigation")[0];
      return nav?.type === 'reload' || performance.navigation?.type === 1;
    } catch {
      return true;
    }
  }

  _hideInstant() {
    this.classList.add('no-transition');
    this.classList.remove('active');
    Object.assign(this.style, {
      opacity: 0,
      visibility: 'hidden',
      pointerEvents: 'none',
    });
    setTimeout(() => this.classList.remove('no-transition'), 50);
  }

  _handleClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest?.('a');
    if (!a?.href) return;

    const href = a.getAttribute('href');
    const classListToIgnore = ['no-transition', 'product__media-icon', 'header__icon--cart', 'button'];
    if (
      a.hasAttribute('download') || (a.target && a.target !== '_self') || a.relList.contains('external') ||
      a.hasAttribute('data-no-transition') || a.href.startsWith('mailto:') ||
      a.href.startsWith('tel:') || href?.startsWith('#') || classListToIgnore.some(cls => a.classList.contains(cls))
    ) return;

    try {
      const url = new URL(a.href, location.href);
      if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol)) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    } catch {
      return;
    }

    e.preventDefault();
    if (this._navigating) return;
    this._navigating = true;
    const destination = a.href;
    // A restored page must not retain inline styles from _hideInstant().
    this.style.opacity = '';
    this.style.visibility = '';
    this.style.pointerEvents = '';
    this.classList.remove('no-transition');
    this.classList.add('active');
    this._navigationTimer = setTimeout(() => {
      this._navigationTimer = null;
      location.href = destination;
    }, this.duration);
  }

  _cancelNavigation() {
    clearTimeout(this._navigationTimer);
    this._navigationTimer = null;
    this._navigating = false;
  }

  _handlePageShow(e) {
    this._cancelNavigation();
    if (e.persisted) this._hideInstant();
  }
}

customElements.define('page-transition', PageTransition);
